// Components
import { requestApi, requestPayoutApi } from './common';

// Types
import type { Shop } from '../types/shop.model';
import type { ShopList } from '../types/shop-list.model';
import type { ShopCommissionSetting } from '../types/shop-commission-setting.model';
import qs from 'qs';
import { RecurringStatementItem } from 'src/types/recurring-statement-item.model';
import { PeppolInfo } from 'src/types/shop-peppol-info.model';

// DELETE
export const removeRecurringCost = ({ id, itemId }): Promise<void> =>
  requestPayoutApi({
    api: `/api/shops/${id}/recurring-statement-item/${itemId}`,
    authorized: true,
    method: 'DELETE'
  });

// GET
export const exists = ({ id }): Promise<{ exists: boolean }> =>
  requestPayoutApi({ api: `/api/shops/${id}/exists`, authorized: true, method: 'GET' });

export const mine = (): Promise<{ shops: Shop[] }> =>
  requestApi({ api: '/api/shops', authorized: true, method: 'GET' });

export const list = ({ filters, skip, take }): Promise<{ shopList: ShopList }> => {
  const params = qs.stringify({ filters, skip, take }, { allowDots: true });
  return requestPayoutApi({
    api: `/api/shops/list?${params}`,
    authorized: true,
    method: 'GET'
  });
};

export const commissionSettings = ({ id }): Promise<{ commissionsSetting: ShopCommissionSetting }> =>
  requestPayoutApi({
    api: `/api/shops/${id}/commissions/setting`,
    authorized: true,
    method: 'GET'
  });

export const getRecurringCosts = ({ id }): Promise<{ recurringItems: RecurringStatementItem[] }> =>
  requestPayoutApi({
    api: `/api/shops/${id}/recurring-statement-items`,
    authorized: true,
    method: 'GET'
  });

export const getPeppolInfo = ({ id }): Promise<{ peppolInfo: PeppolInfo }> =>
  requestPayoutApi({
    api: `/api/shops/${id}/peppol-info`,
    authorized: true,
    method: 'GET'
  });

// POST
export const addCost = ({ id, label, billableAmount }): Promise<void> =>
  requestPayoutApi({
    api: `/api/shops/${id}/statement-item`,
    authorized: true,
    method: 'POST',
    body: { label, billableAmount }
  });

export const addRecurringCost = ({ id, label, billableAmount }): Promise<void> =>
  requestPayoutApi({
    api: `/api/shops/${id}/recurring-statement-items`,
    authorized: true,
    method: 'POST',
    body: { label, billableAmount }
  });

// PUT
export const updateCommissionSettings = ({ id, orderCommission }): Promise<void> =>
  requestPayoutApi({
    api: `/api/shops/${id}/commissions/setting`,
    authorized: true,
    method: 'PUT',
    body: { orderCommission }
  });

export const updatePeppolInfo = ({ id, peppolIdentifier, peppolSchema }): Promise<void> =>
  requestPayoutApi({
    api: `/api/shops/${id}/peppol-info`,
    authorized: true,
    method: 'PUT',
    body: { peppolIdentifier, peppolSchema }
  });
